<template>
    <el-main>
        <el-row>
            <el-col :span="16">
                <div class="main-title">
                    Repossessed Device
                </div>
            </el-col>
        </el-row>

        <div style="margin-top: 24px" v-loading="loadingData">
            <!-- <el-card class="box-card">
                <el-row>
                    <el-col :span="3" style="margin-top: 10px;">
                        <strong>Repossess Date</strong>
                    </el-col>
                    <el-col :span="8">
                        <el-date-picker
                                style="width: 100%"
                                v-model="filter.date"
                                type="daterange"
                                start-placeholder="Start date"
                                end-placeholder="End date"/>
                    </el-col>
                    <el-col :span="3" :offset="2" style="margin-top: 10px;">
                        <strong>Device IMEI</strong>
                    </el-col>
                    <el-col :span="8">
                        <el-input placeholder="Device IMEI No" class="filter-item"/>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 10px">
                    <el-col :span="3" style="margin-top: 10px;">
                        <strong>Country</strong>
                    </el-col>
                    <el-col :span="8">
                        <el-select
                                style="width: 100%"
                                value-key="id"
                                v-model="filter.country"
                                filterable
                                remote
                                clearable
                                auto-complete="nope"
                                placeholder="Select Country">
                            <el-option
                                    v-for="item in countries"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="3" :offset="2" style="margin-top: 10px;">
                        <strong>City</strong>
                    </el-col>
                    <el-col :span="8">
                        <el-select
                                style="width: 100%"
                                value-key="id"
                                v-model="filter.city"
                                filterable
                                remote
                                clearable
                                auto-complete="nope"
                                placeholder="Select City">
                            <el-option
                                    v-for="item in cities"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 15px">
                    <el-button type="primary" icon="el-icon-search">Search</el-button>
                </el-row>
            </el-card> -->

            <el-card  style="margin-top: 24px"  class="box-card">
                <div slot="header" class="clearfix">
                    <span>Filter</span>
                </div>
                <el-row :gutter="8">
                    
                    <el-col :span="4" class="filter-space">
                        <el-input v-model="filter.email" size="small" placeholder="Email Address" class="filter-item"/>
                    </el-col>
                    <el-col :span="4" class="filter-space">
                        <el-input v-model="filter.mobileNumber" size="small" placeholder="Mobile Numnber" class="filter-item"/>
                    </el-col>
                    <!-- <el-col :span="4" class="filter-space">
                        <el-input v-model="filter.contractNumber" size="small" placeholder="Contract/Order Number" class="filter-item"/>
                    </el-col> -->
                    <el-col :span="4" class="filter-space">
                        <el-button  @click="loadData" class="filter-item" size="small" type="primary" icon="el-icon-search">
                            Search
                        </el-button>
                    </el-col>
                </el-row>

                
            </el-card>

            <el-row type="flex" style="margin-top:34px">
                <el-col :span="24">
                    <el-card class="box-card">
                        <!-- <el-row style="margin-bottom: 18px">
                            <el-col style="text-align: end">
                                <el-button type="warning" >Repossess Device</el-button>
                            </el-col>
                        </el-row> -->
                        <el-table
                                :data="devices"
                                style="width: 100%;"
                                :config="{render: 'scroll'}"
                                @row-click="deviceClicked">
                            <!-- <el-table-column
                                    fixed
                                    type="selection"
                                    width="40"/> -->
                            <el-table-column
                                    property="deviceID"
                                    label="Device ID"
                                    width="180"/>
                            <!-- <el-table-column
                                    property="dateTime"
                                    label="Repossessed Date"
                                    width="160"/> -->
                            <!-- <el-table-column
                                    property="repossessBy"
                                    label="Repossess By"
                                    width="160"/> -->
                            <el-table-column
                                    property="lastOwner.email"
                                    label="Last Owner Email"
                                    min-width="200"/>
                            <el-table-column
                                    property="lastOwner.firstName"
                                    label="Last Owner First Name"
                                    min-width="200"/>
                            <el-table-column
                                    property="lastOwner.lastName"
                                    label="Last Owner Last Name"
                                    min-width="200"/>
                            <el-table-column
                                    property="state"
                                    label="Status"
                                    width="150"/>
                            <!-- <el-table-column
                                    property="lastUpdated"
                                    label="Last Updated"
                                    width="120"/> -->
                        </el-table>

                        <pagination v-show="query.total>0" :total="query.total" :page.sync="query.page" :limit.sync="query.limit" @pagination="loadData" />
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <pair-device v-model="pairForm" v-on:submit-form="doPairDevice"/>
    </el-main>
</template>

<script>
import Pagination from "@/components/Pagination"
import api from "@/services/api/WRCService"
import pairDevice from "@/components/PairDevice"

export default {
    components: { 
        Pagination,
        pairDevice
    },
    data: function() {
        return {
            loadingData: false,
            devices: [],
            pairForm: {
                show: false
            },
            filter: {
                email: null,
                mobileNumber: null,
                date: [new Date(2019, 10, 10, 10, 10), new Date(2019, 10, 11, 10, 10)],
                city: null,
                country: null
            },
            query: {
                total: 3,
                page: 1,
                limit: 10
            },
            cities: [
                {
                    id: 1,
                    name: "Kuala Lumpur"
                }
            ],
            countries: [
                {
                    id: 1,
                    name: "Malaysia"
                }
            ],
            multipleSelection: [],
        }
    },
    methods:{
        loadData(){
            this.loadingData = true;

            api.getAvailableDevices(this.filter.email, this.filter.mobileNumber, this.filter.contractNumber, {
                page: this.query.page - 1,
                size: this.query.limit
            }).then(({ data }) => {

                this.devices.splice(0, this.devices.length);
                this.devices.push(...data.data.items);
                this.query.total = data.data.pagination.totalRecords;

            }).catch(() => {}).then(() => {
                this.loadingData = false;
            });
        },
        deviceClicked(row, column, event) {
            //console.log('row clicked: ' + row.id);
            var deviceId = row.id
            this.$router.push({ name: 'DeviceEdit', params: { deviceId } })
        },
        assignDevice(device) {
            var deviceID = device.deviceID
            this.pairForm = {
                show: true,
                deviceID: deviceID
            }
        },
        doPairDevice() {
            this.pairForm.show = false

            var param = {
                email: this.pairForm.email,
                deviceID: this.pairForm.deviceID,
                firstName: this.pairForm.firstName,
                lastName: this.pairForm.lastName,
                gsrCountryId: this.pairForm.country.id,
                city: this.pairForm.city,
                contactNumber: this.pairForm.mobileNo
            }

            this.loadingData = true

            api.pairDevice(param)
            .then(({ data }) => {

                this.$message({
                    message: 'Assigned device.',
                    type: 'success'
                });

                this.loadData()

            }).catch(() => {
                
            }).then(() => {
                this.loadingData = false
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>

<style scoped>

</style>
